import React from 'react';
import { connect } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';
import HeadingBlock from '$/components/global/heading';
import HeadTab from '$/components/global/headingTab';
import UserActivity from './UserActivity';
import { AppState } from '$/store';
import { getBixbyComplianceFeatureFlagState } from '$/store/release-feature-flags/selectors';
import { getIsCurrentUserClientComplianceAdminState } from '$/store/profile/selectors';
import './index.scss';
import CompanyAccess from '$/pages/client/compliance/CompanyAccess';
import CompanyAccessDetail from '$/pages/client/compliance/CompanyAccessDetail';

interface IComplianceProps {
  isClientComplianceAdmin?: boolean;
  hasComplianceAutoApproval?: boolean;
}

const Compliance: React.FC<IComplianceProps> = props => {
  const { isClientComplianceAdmin } = props;
  return isClientComplianceAdmin ? (
    <>
      <React.Fragment>
        <section>
          <HeadingBlock title="Compliance">
            <HeadTab title="Company Access" link={'/compliance'} />
            <HeadTab title="User Activity" link={`/compliance/user-activity`} end={true} />
          </HeadingBlock>
          <div>
            <Routes>
              <Route path={'/*'} element={<CompanyAccess />} />
              <Route path={'/:companyId'} element={<CompanyAccessDetail />} />
              <Route path={'/user-activity'} element={<UserActivity />} />
            </Routes>
          </div>
        </section>
      </React.Fragment>
    </>
  ) : (
    <Navigate to="/portfolio" replace />
  );
};

const mapStateToProps = (state: AppState) => {
  const { isClientComplianceAdmin } = getIsCurrentUserClientComplianceAdminState(state);
  const { isBixbyComplianceEnabled } = getBixbyComplianceFeatureFlagState(state);

  return {
    isClientComplianceAdmin: isBixbyComplianceEnabled && isClientComplianceAdmin,
  };
};

export default connect(mapStateToProps)(Compliance);
